var map = {
	"./certificate-apply.svg": 8190,
	"./certificate-config.svg": 9108,
	"./certificate-query.svg": 6178,
	"./certificate-update.svg": 7617,
	"./certificate.svg": 7777,
	"./check.svg": 5060,
	"./click.svg": 4740,
	"./comment.svg": 9123,
	"./eye-close.svg": 9712,
	"./eye-view.svg": 3775,
	"./home.svg": 1161,
	"./menu.svg": 1473,
	"./refresh.svg": 3269
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 4646;